'use strict';

var Class = {

  //---------- Inheritance API

  /**
   */
  extend: function (properties) {
    var superProto = this.prototype || Class;
    var proto = Object.create(superProto);
    // This method will be attached to many constructor functions
    // => must refer to "Class" via its global name (and not via "this")
    Class.copyOwnTo(properties, proto);

    var constr = proto.constructor;
    if (!(constr instanceof Function)) {
      throw new Error('You must define a method \'constructor\'');
    }
    // Set up the constructor
    constr.prototype = proto;
    constr.super = superProto;
    constr.extend = this.extend; // inherit class method
    return constr;
  },

  /**
   */
  copyOwnTo: function(source, target) {
    Object.getOwnPropertyNames(source).forEach(function(propName) {
      Object.defineProperty(
        target,
        propName,
        Object.getOwnPropertyDescriptor(source, propName)
      );
    });
    return target;
  }
};

const DEFAULT_PAGE_SIZE = 20;



/**
 * `resource` service
 */
const resource = [

  function () {
    var globalOptions = {};

    this.config = function (options) {
      globalOptions = options || {};
    };

    this.$get = [
      '$http',
      '$q',
      '$rootScope',

      function ($http, $q, $rootScope) {

        /**
         * Options:
         * url - {String|Function}
         * pageSize - {Number} default limit for Collection.fetch().
         * params - {Object} default request parameters
         *
         * Actions
         *
         * e.g.
         * {
           *    $fetch: { params: { fields: 'name,age' } },
           *    fetch: { params: { fields: 'name' } }
           * }
         *
         *
         * @param {Object} options
         * @param {Object} [actions]
         */
        return function (options, actions) {
          var Collection;
          var Model;

          actions = actions || {};
          options = options || {};

          normalizeOptions(options);

          function getUrl(id) {
            var url;

            if (angular.isFunction(this._options.url)) {
              url = this._options.url.call(this);
            } else {
              url = this._options.url;
            }

            return (globalOptions.baseUrl || '') + url + (id ? '/' + id : '');
          }

          function getRequestConfig(action, options) {
            var config;
            var params;

            params = angular.extend(
              {},
              this._options.defaultRequestConfig.params,
                this._actions[action] && this._actions[action].params || {},
                options && options.params || {}
            );

            angular.forEach(params, function (param, key) {
              if (angular.isArray(param)) {
                params[key] = param.join(',');
              }
            });

            config = angular.extend(
              {},
              this._options.defaultRequestConfig,
                this._actions[action] || {},
                options || {}
            );

            if (Object.keys(params).length) {
              config.params = params;
            } else {
              delete config.params;
            }

            return config;
          }

          /**
           * Model
           *
           * @param {Object} attributes
           * @constructor
           */
          Model = Class.extend({
            _options: options,
            _actions: actions,

            /**
             * Model contructor.
             *
             * @param {Object} [attributes]
             * @param {Object} [options] - will be accessable as this._constructorOptions
             * @constructor
             */
            constructor: function Model(attributes, options) {
              Object.keys(this._options.nested).forEach(function (attribute) {
                var config = this._options.nested[attribute];
                var constructorOptions = this.$setupOptions(config.options);

                this[attribute] = config.isArray ? config.resource.collection.get(null, constructorOptions) : config.resource.model.get(null, constructorOptions);
                this[attribute]._parentId = attributes && attributes.id;
              }.bind(this));

              this.$set(attributes || {});

              if (angular.isObject(options)) {
                this._constructorOptions = options;
              }
            },

            /**
             * Binds all first level functions to current model instance.
             *
             * @param {Object} options
             * @returns {Object} options with bound functions
             */
            $setupOptions: function (options) {
              var modifiedOptions = angular.copy(options);

              if (angular.isObject(modifiedOptions)) {
                angular.forEach(modifiedOptions, function (property, key) {
                  if (angular.isFunction(property)) {
                    modifiedOptions[key] = property.bind(this);
                  }
                }, this);
              }

              return modifiedOptions;
            },

            /**
             * Makes GET request.
             *
             * Options:
             * params - {Object} query parameters.
             *
             * @param {Object} options
             * @returns {promise}
             */
            $fetch: function (options) {
              var deferred = $q.defer();

              if (!this.$resolved && !this.$promise) {
                this.$promise = deferred.promise;
                this.$resolved = false;
              }

              $http.get(this.$$getUrl(this.id), this.$$getRequestConfig('$fetch', options))
                .then(function (response) {

                  this.$set(response.data);
                  deferred.resolve(response);

                }.bind(this), deferred.reject)

                .finally(function () {
                  if (this.$promise === deferred.promise) {
                    this.$resolved = true;
                    delete this.$promise;
                  }
                }.bind(this));

              return deferred.promise;
            },

            /**
             * Makes PUT request if model has id property. Otherwise POST request is made.
             *
             * Options:
             * params - {Object} query parameters.
             * data - {Object} additional request data.
             * merge - {Boolean} should response data be merged into model? Defaults to true.
             *
             * @param {Object} options
             * @param {Array} [attributes] List of model attributes that should be included in request.
             * @returns {promise}
             */
            $save: function (options, attributes) {
              var method = this.id ? 'put' : 'post';
              var deferred = $q.defer();
              var data;

              options = options || {};

              data = angular.extend(this.$serialize(attributes), options.data || {});

              if (!this.$resolved && !this.$promise) {
                this.$promise = deferred.promise;
                this.$resolved = false;
              }

              $http[method](this.$$getUrl(this.id), data, this.$$getRequestConfig('$save', options))
                .then(function (response) {

                  if (options.merge !== false) {
                    this.$set(response.data);
                  }
                  deferred.resolve(response);

                }.bind(this), deferred.reject)

                .finally(function () {
                  if (this.$promise === deferred.promise) {
                    this.$resolved = true;
                    delete this.$promise;
                  }

                  if (method === 'post' && this.id && this._collection) {
                    this._collection.removeDuplicates(this.id);
                  }
                }.bind(this));

              return deferred.promise;
            },

            /**
             * Makes DELETE request and removes model from collection.
             * @returns {promise}
             */
            $destroy: function (options) {
              var deferred = $q.defer();

              $http.delete(this.$$getUrl(this.id), this.$$getRequestConfig('$destroy', options))
                .then(function (response) {

                  this._collection && this._collection.remove(this);
                  deferred.resolve(response);

                }.bind(this), deferred.reject);

              return deferred.promise;
            },

            /**
             * Returns object that contains only public model's attributes.
             * If `attributes` array is provided, returned object will contain only those attributes.
             *
             * @param {Array} [attributes]
             * @returns {Object}
             */
            $serialize: function (attributes) {
              var copy = angular.extend({}, this);

              if (attributes) {
                attributes = angular.isArray(attributes) ? attributes : [attributes];
              }

              angular.forEach(copy, function (attribute, key) {
                if (key.substr(0, 1) === '_' || key.substr(0, 1) === '$' || (attributes && attributes.indexOf(key) === -1)) {
                  delete copy[key];
                } else if (attribute && attribute.hasOwnProperty && attribute.hasOwnProperty('_parentId')) {
                  copy[key] = attribute.$serialize();
                }
              });

              copy = angular.copy(copy);

              return copy;
            },

            /**
             * Merges data.
             *
             * @param {Object} attributes
             */
            $set: function (attributes) {
              var nestedData = {};

              attributes = angular.extend({}, attributes);

              Object.keys(this._options.nested).forEach(function (attribute) {
                if (attributes[attribute]) {
                  nestedData[attribute] = attributes[attribute];
                  delete attributes[attribute];
                }
              });
              angular.extend(this, attributes);

              Object.keys(nestedData).forEach(function (attribute) {
                var nested = this[attribute],
                  config;

                if (nested) {
                  config = this._options.nested[attribute];

                  if (config.isArray) {
                    if (nestedData[attribute].length > 0) {
                      nested.add(nestedData[attribute]);
                    }

                  } else {
                    nested.$set(nestedData[attribute]);
                  }
                }
              }.bind(this));
            },

            /**
             * Makes all properties undefined and resets nested properties.
             */
            $reset: function () {
              angular.forEach(this, function (property, key) {
                if (this._options.nested[key]) {
                  if (this._options.nested[key].isArray) {
                    property.reset();
                  } else {
                    property.$reset();
                  }
                } else if (key.charAt(0) !== '_' && key.charAt(0) !== '$') {
                  delete this[key];
                }
              }, this);
            },

            $$getUrl: getUrl,

            $$getRequestConfig: getRequestConfig
          });

          /**
           * Collection
           *
           * @constructor
           */
          Collection = Class.extend({
            _options: options,
            _actions: actions,
            _Model: Model,

            /**
             * Collection constructor.
             *
             * @param {Array|Object|Model} [models]
             * @param {Object} [options] - will be accessable as this._constructorOptions
             * @constructor
             */
            constructor: function Collection(models, options) {
              this._constructorOptions = options || {};

              this.length = 0;
              this.hasMore = true;
              this.offsetModifier = 0;
              this._onBeforeAdd = [];
              this._onAdd = [];
              this._onRemove = [];
              this._onReset = [];
              this._isCollection = true;
              this._duplicateCount = 0;
              this.name = options && options.name;

              models && this.add(models);
            },

            /**
             * Destructor.
             */
            destroy: function () {
              delete this.name;
            },

            /**
             * Makes GET request and adds return models to collection.
             *
             * Options:
             * all - {Boolean} fetch all models.
             * offset - {Number}
             *
             * @param {Object} options
             * @returns {promise}
             */
            fetch: function (options) {
              var deferred = $q.defer();
              var forceOffset;

              options = angular.copy(options) || {};

              if (!options.all) {
                options.params = options.params || {};
                forceOffset = !angular.isUndefined(options.params.offset);

                options.params.offset = forceOffset ?
                  options.params.offset :
                  (options.reset ? 0 : this.length + this.offsetModifier);

                /*
                 * Increase offset by duplicate count.
                 * Needed in matches, because of API cache.
                 * Enabled by passing { ignoreDuplicates: true } to constructor options.
                 */
                if (this._constructorOptions.ignoreDuplicates && this._duplicateCount && !forceOffset) {

                  if (!options.reset) {
                    options.params.offset += this._duplicateCount || 0;
                  }

                }

                options.params.limit = options.params.limit || this._options.pageSize || DEFAULT_PAGE_SIZE;
              }

              if (!this.resolved && !this.promise) {
                this.promise = deferred.promise;
                this.resolved = false;
              }

              this.isFetching = true;

              $http.get(this.url(), this._getRequestConfig('fetch', options))
                .then(function (response) {
                  if (options.reset) {
                    this.reset();
                  }

                  if (options.all) {
                    this.hasMore = false;
                  } else {
                    this.hasMore = (response.data.length === options.params.limit);
                  }

                  deferred.resolve(this.add(response.data));

                }.bind(this), deferred.reject)

                .finally(function () {
                  delete this.isFetching;

                  if (this.promise === deferred.promise) {
                    this.resolved = true;
                    delete this.promise;
                  }
                }.bind(this));

              return deferred.promise;
            },

            /**
             * Calls `fetch` method with `all` option.
             *
             * @param options
             * @returns {promise}
             */
            fetchAll: function (options) {
              options = options || {};
              options.all = true;

              return this.fetch(options);
            },

            /**
             * Adds one or multiple models to collection.
             * If model with the same id already exists in collection, it's properties will be merged.
             *
             * Using options.index you can specify index where to insert the new models at.
             *
             * @param {Array|Object|Model} models
             * @param {Object} options
             */
            add: function (models, options) {
              var addedModels = [];
              var insertionOffset = 0;
              var duplicates = [];
              var shouldInsertAtIndex;
              var insertAt;

              options = options || {};

              shouldInsertAtIndex = angular.isDefined(options.index);

              models = angular.isArray(models) || models._isCollection ? models : [models];
              this._executeCallbacks('_onBeforeAdd', models);

              models.forEach(function (model) {
                var index;
                var ids;

                if (this.indexOf(model) > -1) {
                  this.sort();
                  return;
                }

                model = (model instanceof Model) ? model : this.create(model);
                model._parentId = this._parentId;
                if (model.id && !index) {
                  ids = this.pluck('id');
                  index = ids.indexOf(model.id);
                }

                model._collection = this;

                if (index > -1) {
                  insertAt = index;

                  this[insertAt].$set(model);
                  duplicates.push(model);
                } else {
                  insertAt = insertionOffset + (shouldInsertAtIndex ? options.index : this.length);

                  if (shouldInsertAtIndex) {
                    insertionOffset++;
                  }

                  this.splice(insertAt, 0, model);
                }

                addedModels.splice(insertAt, 0, model);

              }.bind(this));

              this.sort();

              this._executeCallbacks('_onAdd', models);

              if (this.name) {
                $rootScope.$emit(this.name + ':added', addedModels);
              }

              this._duplicateCount += duplicates.length;

              return addedModels;
            },

            /**
             * Removes one or multiple models from collection.
             *
             * @param {Array|Model} models
             * @returns {Array}
             */
            remove: function (models, options) {
              var removed = [];
              var isReset = angular.isObject(options) ? options.isReset : false;

              if (models === this) {
                models = this.slice();
              }

              models = angular.isArray(models) ? models : [models];

              models.forEach(function (model) {
                var index = this.indexOf(model);

                if (index > -1) {
                  removed.push(this.splice(index, 1)[0]);
                }
              }.bind(this));

              this._executeCallbacks('_onRemove', removed);

              if (this.name) {
                $rootScope.$emit(this.name + ':removed', removed, isReset);
              }

              return removed;
            },

            /**
             * Returns model by id.
             *
             * @param {String|Number} id
             * @returns {Model|undefined}
             */
            'get': function (id) {
              var index = this.map(function (model) {
                return (!angular.isUndefined(model.id) && model.id + '') || undefined;
              }).indexOf(id + '');


              if (index > -1) {
                return this[index];
              }
            },

            /**
             * Sorts collection.
             */
            sort: function () {
              var comparator = options.comparator;
              var isDescending;

              if (!comparator) {
                return;
              }

              isDescending = (angular.isString(comparator) && comparator.charAt(0) === '-');
              if (isDescending) {
                comparator = comparator.substr(1);
              }

              Array.prototype.sort.call(this, angular.isFunction(comparator) ? comparator : function (a, b) {
                var aIsUndefined = angular.isUndefined(a[comparator]),
                  bIsUndefined = angular.isUndefined(b[comparator]);

                if (aIsUndefined && bIsUndefined) {
                  return 0;
                } else if (aIsUndefined) {
                  return 1;
                } else if (bIsUndefined) {
                  return -1;
                }

                return parseFloat(a[comparator]) - parseFloat(b[comparator]);
              });

              if (isDescending) {
                Array.prototype.reverse.call(this);
              }
            },

            pluck: function (attribute) {
              return this.map(function (model) {
                return model[attribute];
              });
            },

            onBeforeAdd: function (callback) {
              this._onBeforeAdd.push(callback);
            },

            onAdd: function (callback) {
              this._onAdd.push(callback);
            },

            onRemove: function (callback) {
              this._onRemove.push(callback);
            },

            onReset: function (callback) {
              this._onReset.push(callback);
            },

            /**
             * Removes all models from collection.
             */
            reset: function () {
              this.remove(this, {
                isReset: true
              });
              this.hasMore = true;
              this.offsetModifier = 0;
              this._duplicateCount = 0;
              this._executeCallbacks('_onReset');

              if (this.name) {
                $rootScope.$emit(this.name + ':reset');
              }
            },

            /**
             * Creates and returns new instance of Model with provided attributes.
             *
             * @param {Object} attributes
             * @returns {Model}
             */
            create: function (attributes) {
              var modelOptions = angular.isObject(this._constructorOptions) ? this._constructorOptions : null;

              return new this._Model(attributes, modelOptions);
            },

            removeDuplicates: function (id) {
              var modelsWithSameIds = this.filter(function (model) {
                  return (model.id === id);
                }),
                duplicateModels;

              if (modelsWithSameIds.length > 1) {
                duplicateModels = modelsWithSameIds.slice(1);

                this.remove(duplicateModels);
              }
            },

            $serialize: function () {
              var collectionArray = this.map(function (model) {
                return model.$serialize();
              });

              return collectionArray;
            },

            url: getUrl,

            _getRequestConfig: getRequestConfig,

            _executeCallbacks: function (name) {
              var args = Array.prototype.slice.call(arguments, 1);

              this[name].forEach(function (callback) {
                callback.apply(this, args);
              }.bind(this));
            }
          });

          ['splice', 'indexOf', 'map', 'forEach', 'filter', 'slice'].forEach(function (methodName) {
            Collection.prototype[methodName] = Array.prototype[methodName];
          });

          return {
            model: {
              _Model: Model,

              /**
               * Returns new Model instance.
               *
               * @param {Object} [attributes]
               * @returns {Model}
               */
              'get': function (attributes, options) {
                return new this._Model(attributes, options);
              },

              /**
               * Extends Model.prototype.
               *
               * @param {Object} obj
               */
              extend: function (obj) {
                angular.extend(this._Model.prototype, obj);
              }
            },
            collection: {
              _Collection: Collection,

              /**
               * Returns new Collection instance.
               *
               * @param {Array|Object|Model} [models]
               * @returns {Collection}
               */
              'get': function (models, options) {
                return new this._Collection(models, options);
              },

              /**
               * Extends Collection.prototype.
               *
               * @param {Object} obj
               */
              extend: function (obj) {
                angular.extend(this._Collection.prototype, obj);
              }
            },
            extend: function (options, actions) {
              var clone = angular.copy(this);
              var parentOptions = clone.model._Model.prototype._options;
              var parentActions = clone.model._Model.prototype._actions;
              var extendedOptions;
              var extendedActions;

              actions = actions || {};
              options = options || {};

              extendedOptions = angular.extend({}, parentOptions, normalizeOptions(options));
              extendedActions = angular.extend({}, parentActions, actions);

              // extend nested options separatly because angular.extend is not deep.
              angular.extend(extendedOptions.nested, parentOptions.nested);

              clone.model._Model = this.model._Model.extend({
                _options: extendedOptions,
                _actions: extendedActions,

                constructor: function () {
                  clone.model._Model.super.constructor.apply(this, arguments);
                }
              });

              clone.collection._Collection = this.collection._Collection.extend({
                _options: extendedOptions,
                _actions: extendedActions,
                _Model: clone.model._Model,

                constructor: function () {
                  clone.collection._Collection.super.constructor.apply(this, arguments);
                }
              });

              return clone;
            }
          };
        };
      }
    ];
  }
];

function normalizeOptions(options) {
  var defaultRequestConfig = {};

  if (options.params) {
    defaultRequestConfig.params = options.params;
    delete options.params;
  }

  options.defaultRequestConfig = defaultRequestConfig;
  options.nested = options.nested || {};

  return options;
}

export default resource;



// WEBPACK FOOTER //
// ./app/src/services/resource.js